import { emitter } from '@/helpers/emitter';

export const subscribeToFilterUpdates = (callback) => {
  emitter.on('updatedFilters', callback);
};

export const unsubscribeToFilterUpdates = () => {
  emitter.off('updatedFilters');
};
